enum Permissions {
  AREAS_READ = 'area_management.read',
  AREAS_WRITE = 'area_management.write',
  MAPPINGS_READ = 'mappings.read',
  MAPPINGS_WRITE = 'mappings.write',
  MAPPINGS_WRITE_RESTRICTED = 'mappings.write.restricted',
  OPERATION_GROUPS_READ = 'operation_groups.read',
  OPERATION_GROUPS_WRITE = 'operation_groups.write',
  PERMISSIONS_READ = 'permissions.read',
  PICKING_AREAS_READ = 'picking_areas.read',
  PICKING_AREAS_WRITE = 'picking_areas.write',
  PRESETS_WRITE = 'presets.write',
  ROLES_READ = 'roles.read',
  ROLES_WRITE = 'roles.write',
  SHELFLABELING_READ = 'shelf_labeling.read',
  SHELFLABELING_WRITE = 'shelf_labeling.write',
  SYSTEMSTATUS_READ = 'system_status.read',
  TEMPLATES_READ = 'templates.read',
  TEMPLATES_WRITE = 'templates.write',
  USERS_READ = 'users.read',
  USERS_WRITE = 'users.write',
  LINK_PROFILES_READ = 'link_profile.read',
  LINK_PROFILES_WRITE = 'link_profile.write',
  COMPARTMENT_SELECTORS_READ = 'compartment_selector.read',
  COMPARTMENT_SELECTORS_WRITE = 'compartment_selector.write',
  FINDERS_READ = 'finder.read',
  FINDERS_WRITE = 'finder.write',
  DEVICE_POOLS_READ = 'device_pool.read',
  DEVICE_POOLS_WRITE = 'device_pool.write',
  ZONES_READ = 'picking_zones.read',
  ZONES_WRITE = 'picking_zones.write',
  UPDATER_PROFILE_READ = 'updater_profile.read',
  UPDATER_PROFILE_WRITE = 'updater_profile.write',
  BLUEPRINTS_READ = 'blueprints.read',
  BLUEPRINTS_WRITE = 'blueprints.write',
  PICKER_PROFILES_READ = 'picker_profiles.read',
  PICKER_PROFILES_WRITE = 'picker_profiles.write',
  EKANBAN_READ = 'ekanban.read',
  EKANBAN_WRITE = 'ekanban.write',
  EVENT_RULES_READ = 'event_rules.read',
  EVENT_RULES_WRITE = 'event_rules.write',
  TASKS_READ = 'tasks.read',
}

export default Permissions;
